<template>
  <div class="mt-2">
    <f-tabs
      v-if="loaded"
      ref="customer-tabs"
      :items="tabItems"
      :tabsVertical="true"
      :withCompletion="false">
      <div slot="tab-0">
        <customer-agreements-form
          :readonly="userType !== 'customer'"
          :acceptedTermsAndPolicy="!!customer.accepted_terms_and_policy_privacy"
          :contactAdviserAgreement="!!customer.contact_adviser_agreement"
          :contactFinhubAgreement="!!customer.contact_finhub_agreement"/>
      </div>
      <div slot="tab-1">
        <div class="card is-smallshadow">
          <customer-form
            :readonly="userType !== 'customer'"
            :id="customer.id"
            :name="customer.name"
            :surname="customer.surname"
            :email="customer.email"
            :phone="customer.phone"
            :city="customer.city"
            :postCode="customer.post_code"
            :address="customer.address ? customer.address : '' "
            :acceptedTermsAndPolicy="!!customer.accepted_terms_and_policy_privacy"
            :contactAdviserAgreement="!!customer.contact_adviser_agreement"
            :contactFinhubAgreement="!!customer.contact_finhub_agreement"/>
        </div>
      </div>
      <div slot="tab-2">
        <div class="card is-smallshadow">
          <user-settings-passowrd-change />
        </div>
      </div>
    </f-tabs>
    <div
      v-if="!loaded"
      class="loading-spinner-wrapper">
      <div class="loading-spinner pb-3 pt-3">
        <span class="loading-spinner-content">
          {{ $t('ui.loadingDataInProgress') }}&hellip;
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import FormUtils from '@/utils/FormUtils.js';
import ListUtils from '@/utils/ListUtils.js';
import CustomerAgreementsForm from './CustomerAgreementsForm.vue';
import CustomerForm from './CustomerForm.vue';
import UserSettingsPasswordChange from '@/views/forms/settings/UserSettingsPasswordChange.vue';

export default {
  name: 'customer-settings',
  components: {
    'customer-agreements-form': CustomerAgreementsForm,
    'customer-form': CustomerForm,
    'user-settings-passowrd-change': UserSettingsPasswordChange
  },
  props: {
    customer: {
      type: Object,
      required: true
    }
  },
  computed: {
    tabItems () {
      let items = [
        {
          title: this.$t('customerSettings.marketingConsents'),
        }
      ]

      if (this.userType === 'customer') {
        items.push({
          title: this.$t('customerForm.myData'),
        });
        items.push({
          title: this.$t('user.changePassword'),
        });
      } else {
        items.push({
          title: this.$t('customerForm.customerData'),
        });
        items.push({
          title: this.$t('customerSettings.deleteCustomer'),
          isAction: true,
          theme: 'danger',
          function: this.removeCustomer
        });
      }
      return items;
    },
  },
  data() {
    return {
      userType: null,
      removeInProgress: false,
      loaded: false
    }
  },
  mounted() {
    this.userType = this.$store.getters['getUserType'].toLowerCase();
    this.loaded = true;
  },
  methods: {
    submitForm (formData) {
      let formDataToSend = this.prepareFormDataToSend(formData);
      let endpointUrl = '/api/customer/customer/update';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: this.$t('ui.savedChanges'),
        successText: this.$t('customerAgreementsForm.yourProfileHasBeenUpdate'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('customerAgreementsForm.updateProfileError'),
        successAction: () => {
          this.$bus.$emit('customer-settings-reload');
        }
      });
    },
    prepareFormDataToSend (formData) {
      let formDataToSend = JSON.parse(JSON.stringify(this.customer));

      let fieldsToSave = Object.keys(formData);

      for (let i = 0; i < fieldsToSave.length; i++) {
        formDataToSend[fieldsToSave[i]] = formData[fieldsToSave[i]] ? 1 : 0;
      }

      return formDataToSend;
    },
    removeCustomer () {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/api/adviser/customers/delete/',
        id: this.customer.id,
        successTitle: this.$t('customersList.deleteAccountCustomer'),
        successText: this.$t('customersList.deleteSelectAccountCustomer'),
        confirmTitle: this.$t('customersList.doYouWantDeleteAccountCustomer'),
        confirmText: this.$t('ui.thisOperationCannotUndone'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('customersList.deleteAccountCustomerError'),
        successAction: () => {
          this.$router.push('/klienci');
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    },
  }
}
</script>
